<div class="container">
  <h1 class="text-center">Edit Role Permissions (Firestore)</h1>
  <div class="justify-content-end d-flex">
    <button mat-raised-button color="primary"  (click)="openDialog()">
      Add Role functions
    </button>
  </div>
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-4" *ngIf="((roles$|async)?.length || 0) >= 1">
      <mat-label>SELECT ROLE</mat-label>
      <mat-select [(ngModel)]="roleSelected" (selectionChange)="onRoleSelect($event)"  >
        <mat-option *ngFor="let r of roles$|async" [value]="r.id" > {{r.id}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="col-md-1 col-sm-12">
      <button mat-icon-button matSuffix aria-label="Add Role Dialog" matTooltip="Role Dialog" (click)="openAddRoleDialog(addRoleDialog)">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <ng-template #addRoleDialog>
    <h2 mat-dialog-title>Add New Role</h2>
    <mat-dialog-content>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Role Name</mat-label>
        <input matInput [(ngModel)]="newRoleName" />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-flat-button color="primary" (click)="confirmAddRole()">Add</button>
    </mat-dialog-actions>
  </ng-template>

  <table class="table mt-4 ">
    <thead>
    <tr >
      <th class="head">MySpace Function</th>
      <th class="head">All</th>
      <th class="head">Add</th>
      <th class="head">Edit</th>
      <th class="head">Archive</th>
      <th class="head">View</th>
      <th class="head">Excel</th>
      <th class="head">Menu</th>
      <th class="head">Action</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let d of permissionsData; let i = index">
      <tr *ngIf="i === 0 || permissionsData[i - 1]?.group !== d.group" class="group-separator">
        <td class="font-bold menu-header">{{ d.group || 'Ungrouped' }}</td>
        <td class="text-center menu-header">
          <input type="checkbox" title="Select all in group"
                 [checked]="isGroupColumnChecked(d.group, 'all')"
                 (change)="toggleGroupColumn(d.group, 'all', $event)">
        </td>
        <td class="text-center menu-header">
          <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'add')"
                 (change)="toggleGroupColumn(d.group, 'add', $event)">
        </td>
        <td class="text-center menu-header">
          <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'edit')"
                 (change)="toggleGroupColumn(d.group, 'edit', $event)">
        </td>
        <td class="text-center menu-header">
          <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'archive')"
                 (change)="toggleGroupColumn(d.group, 'archive', $event)">
        </td>
        <td class="text-center menu-header">
          <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'view')"
                 (change)="toggleGroupColumn(d.group, 'view', $event)">
        </td>
        <td class="text-center menu-header">
          <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'excel')"
                 (change)="toggleGroupColumn(d.group, 'excel', $event)">
        </td>
        <td class="text-center menu-header">
          <input type="checkbox" [checked]="isGroupColumnChecked(d.group, 'showMenu')"
                 (change)="toggleGroupColumn(d.group, 'showMenu', $event)">
        </td>
        <td class="menu-header"></td>
      </tr>
      <tr>
              <td *ngIf="d.functionName!='Employee'" >{{d.functionName}}</td>
              <td *ngIf="d.functionName=='Employee'" >Users</td>
              <td><input type="checkbox" [(ngModel)]="d.all" (change)="selectionChangeRoleCheckBox(d.all,d.id,'all')"></td>
              <td><input type="checkbox" [(ngModel)]="d.add" (change)="selectionChangeRoleCheckBox(d.add,d.id,'add')"></td>
              <td><input type="checkbox" [(ngModel)]="d.edit"  (change)="selectionChangeRoleCheckBox(d.edit,d.id,'edit')"></td>
              <td><input type="checkbox" [(ngModel)]="d.archive"  (change)="selectionChangeRoleCheckBox(d.archive,d.id,'archive')"></td>
              <td><input type="checkbox" [(ngModel)]="d.view"  (change)="selectionChangeRoleCheckBox(d.view,d.id,'view')"></td>
              <td><input type="checkbox" [(ngModel)]="d.excel"  (change)="selectionChangeRoleCheckBox(d.excel,d.id,'excel')"></td>
              <td><input type="checkbox" [(ngModel)]="d.showMenu"  (change)="selectionChangeRoleCheckBox(d.showMenu,d.id,'showMenu')"></td>
              <td>
                <button color="warn" mat-icon-button   (click)="deletePermission(d.id)" matTooltip="Delete" ><mat-icon>delete</mat-icon>&nbsp;</button>&nbsp;
              </td>
      </tr>
      <tr *ngIf="i < permissionsData.length - 1 && permissionsData[i]?.group !== permissionsData[i + 1]?.group" class="divider">
        <td colspan="9" class="border-top"></td>
      </tr>
    </ng-container>
    </tbody>


<!--    <tbody>-->
<!--    <tr *ngFor="let d of (permissionsData)">-->
<!--      <td *ngIf="d.functionName!='Employee'" >{{d.functionName}}</td>-->
<!--      <td *ngIf="d.functionName=='Employee'" >Users</td>-->
<!--      <td><input type="checkbox" [(ngModel)]="d.all" (change)="selectionChangeRoleCheckBox(d.all,d.id,'all')"></td>-->
<!--      <td><input type="checkbox" [(ngModel)]="d.add" (change)="selectionChangeRoleCheckBox(d.add,d.id,'add')"></td>-->
<!--      <td><input type="checkbox" [(ngModel)]="d.edit"  (change)="selectionChangeRoleCheckBox(d.edit,d.id,'edit')"></td>-->
<!--      <td><input type="checkbox" [(ngModel)]="d.archive"  (change)="selectionChangeRoleCheckBox(d.archive,d.id,'archive')"></td>-->
<!--      <td><input type="checkbox" [(ngModel)]="d.view"  (change)="selectionChangeRoleCheckBox(d.view,d.id,'view')"></td>-->
<!--      <td><input type="checkbox" [(ngModel)]="d.excel"  (change)="selectionChangeRoleCheckBox(d.excel,d.id,'excel')"></td>-->
<!--      <td><input type="checkbox" [(ngModel)]="d.showMenu"  (change)="selectionChangeRoleCheckBox(d.showMenu,d.id,'showMenu')"></td>-->
<!--      <td>-->
<!--        <button color="warn" mat-icon-button   (click)="deletePermission(d.id)" matTooltip="Delete" ><mat-icon>delete</mat-icon>&nbsp;</button>&nbsp;-->
<!--      </td>-->
<!--    </tr>-->

<!--    </tbody>-->
  </table>
</div>
